import { styled } from 'styled-components';

const FormRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spaceMd};

  & > * {
    width: 100%;
  }
`;

export default FormRow;